import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateVariationMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateVariationMaster = createAsyncThunk('updateVariationMaster', async (payload) => {
  return await updateVariationMasterApi(payload);
});

const updateVariationMasterSlice = createSlice({
  name: 'updateVariationMaster', // Unique Name
  initialState,
  reducers: {
    updateVariationMasterReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateVariationMaster.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateVariationMaster.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateVariationMaster.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateVariationMasterReset } = updateVariationMasterSlice.actions;

export default updateVariationMasterSlice.reducer;
